export default {
  state: {
    addressInfo: {
      address: "请选择地址",
      name: "",
      tel: ""
    }
  },

  mutations: {
    updateAddress(state, payload) {
      state.addressInfo = payload;
    }
  }
};
